import React from "react";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { LeaderboardTab } from "@/components/LeaderboardTab";
import { useReferrals } from "@/providers/ReferralsProvider";
import { ReferralBottomNav } from "@/components/ReferralBottomNav";
import { useUserStats } from "@/hooks/useLeaderboard";

export const LeaderboardPage: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString();
  const { data } = useReferrals();
  const { data: userStats } = useUserStats(userId);

  if (!data) {
    return null;
  }

  const userPoints = userStats?.totalPoints ?? 0;
  const userRank = data.referralStats.userRank;

  // Non-whitelisted users get full screen
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <LeaderboardTab
          leaderboard={data.leaderboard}
          referralCount={data.referralStats.totalReferrals}
          userRank={userRank}
          userPoints={userPoints}
        />
      </div>
      <ReferralBottomNav />
    </div>
  );
};
